import { render, staticRenderFns } from "./remote-search.vue?vue&type=template&id=4d8e32bc&scoped=true"
import script from "./remote-search.vue?vue&type=script&lang=js"
export * from "./remote-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e32bc",
  null
  
)

export default component.exports